import React from "react";
import styles from "./style.module.css";

import "rc-slider/assets/index.css";

import Slider, { Range } from "rc-slider";

import { LineInput } from "components/Inputs/LineInput";

export default class RangeSlider extends React.Component {
  state = {
    tempValue: this.props.value ? [...this.props.value] : [0, 1],
    updatePointer: null
  };

  componentDidUpdate(prevProps) {
    const { value } = this.props;
    const { tempValue, updatePointer } = this.state;

    if (
      value &&
      tempValue &&
      updatePointer === null &&
      ((!isNaN(tempValue[0]) && value[0] !== tempValue[0]) || (!isNaN(tempValue[1]) && value[1] !== tempValue[1]))
    ) {
      this.setState({
        tempValue: [...value]
      });
    }
  }

  handleChange(val) {
    const { onChange } = this.props;
    const { tempValue, updatePointer } = this.state;
    if (updatePointer !== null) {
      clearTimeout(updatePointer);
    }
    const tempPointer = setTimeout(() => {
      this.setState({
        updatePointer: null
      });
      onChange(val);
    }, 100);
    this.setState({
      tempValue: val,
      updatePointer: tempPointer
    });
  }

  render() {
    const {
      min,
      max,
      label,
      onChange,
      value,
      step,
      marks,
      isDollar,
      isLocked,
      isWideLabel,
      hideInput,
      hideSlider,
      className,
      style,
      endLabel,
      startLabel,
      trackStyle,
      handleStyle,
      railStyle,
      isMiniOptimize,
      inputSliderClassName,
      sliderStyle,
      inputStyle
    } = this.props;
    const { tempValue } = this.state;

    return (
      <div className={(className ? className : "") + " " + styles.sliderHolder} style={style ? { ...style } : {}}>
        <div
          className={styles.label}
          style={label === undefined ? { display: "None" } : isWideLabel ? { width: "200px" } : {}}
        >
          {label}
        </div>
        {hideInput !== true ? (
          <div className={styles.inputLine} style={{ width: isMiniOptimize ? "50px" : undefined, ...inputStyle }}>
            <LineInput
              min={min}
              max={max}
              onChange={(val) => onChange([val, value ? value[1] : val])}
              value={value[0] === 0 ? "0" : value[0]}
              isDollar={isDollar}
              isMediumBox
              isLocked={isLocked}
              topLabel={startLabel}
            />
          </div>
        ) : (
          <div />
        )}
        {hideSlider !== true && (
          <div
            className={styles.inputSlider + " " + inputSliderClassName}
            style={{ marginRight: "0px", ...sliderStyle }}
          >
            <Range
              type="range"
              min={min}
              max={max}
              onChange={isLocked ? () => {} : (value) => this.handleChange(value)}
              value={tempValue}
              step={step ? step : 1}
              marks={marks}
              pushable
              trackStyle={[{ backgroundColor: "var(--aible-color)", ...trackStyle }]}
              handleStyle={(handleStyle || [{}, {}]).map((hStyle) => ({
                backgroundColor: "var(--aible-color)",
                borderColor: "white",
                boxShadow: "0px 0px 6px 1px rgba(81, 47, 119, 0.35)",
                ...hStyle
              }))}
              railStyle={railStyle}
            />
          </div>
        )}
        {hideInput !== true ? (
          <div className={styles.inputLine} style={{ width: isMiniOptimize ? "50px" : undefined, ...inputStyle }}>
            <LineInput
              min={min}
              max={max}
              onChange={(val) => onChange([value ? value[0] : val, val])}
              value={value[1]}
              isDollar={isDollar}
              isMediumBox
              isLocked={isLocked}
              topLabel={endLabel}
            />
          </div>
        ) : (
          <div />
        )}
      </div>
    );
  }
}
